<template>
	<div class="flex flex-col">
		<div v-if="!companyLayout && match" class="mb-2">
			<h2
				:class="
					match.details.hardskillAverage >= 50
						? 'text-green-600'
						: 'text-red-500'
				"
			>
				{{ match.details.hardskillAverage }}%
				{{ $t('general.hardskills') }}
			</h2>
		</div>
		<div>
			<GeneralTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
				:heading-key="
					companyLayout
						? 'applicant-profile-modal.details'
						: 'general.information'
				"
			/>
		</div>
		<div>
			<DetailTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
				:heading-key="
					companyLayout
						? 'applicant-profile-modal.job-information'
						: 'general.details'
				"
			/>
		</div>
		<div>
			<ProvinceTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
			/>
		</div>
		<div>
			<EducationTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
			/>
		</div>
		<div>
			<RequirementTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
			/>
		</div>
		<div>
			<LanguageTable
				:job-offer="jobOffer"
				:applicant-profile="applicantProfile"
				:match="match"
			/>
		</div>
	</div>
</template>

<script>
import GeneralTable from '~/components/crud/tables/GeneralTable'
import DetailTable from '~/components/crud/tables/DetailTable'
import ProvinceTable from '~/components/crud/tables/ProvinceTable'
import EducationTable from '~/components/crud/tables/EducationTable'
import RequirementTable from '~/components/crud/tables/RequirementTable'
import LanguageTable from '~/components/crud/tables/LanguageTable'

export default {
	components: {
		GeneralTable,
		DetailTable,
		ProvinceTable,
		EducationTable,
		RequirementTable,
		LanguageTable
	},
	props: {
		jobOffer: { type: Object, default: null },
		applicantProfile: { type: Object, required: true },
		match: { type: Object, default: null },
		companyLayout: { type: Boolean, default: false }
	}
}
</script>
